import {useParams} from "react-router-dom";
import {IBuildType} from "@evennt-tech/api-v2-core";
import {useLocalisedLanguageCode} from "hooks/translation";
import {useBuildTypes} from "store/build-type/build-type.store";
import {useShows} from "store/show/show.store";
import {useEffect} from "react";
import {shallow} from "zustand/shallow";

type UseCurrentShowBuildTypesResult = [IBuildType[], boolean];

type Args = {
  localised?: boolean;
};

export default ({
  localised = false,
}: Args = {}): UseCurrentShowBuildTypesResult => {
  const {showId} = useParams<{showId?: string}>();
  const languageCode = useLocalisedLanguageCode(localised);

  const {
    fetch: fetchBuildTypesInShow,
    autoCatch: autoCatchBuildTypes,
  } = useBuildTypes();

  const buildTypes = useBuildTypes(
    (state) => state.getByShowId(showId as string),
    shallow
  );

  const isLoading = useBuildTypes((state) => state.isLoading, shallow);

  const organiserCompanyId = useShows(
    (state) =>
      state.selected?.id === showId
        ? state.selected?.organiserCompanyId
        : undefined,
    shallow
  );

  useEffect(() => {
    if (!showId) {
      return;
    }

    const load = async () => {
      await autoCatchBuildTypes(showId, organiserCompanyId);
      await fetchBuildTypesInShow(showId, false, languageCode);
    };

    load();
  }, [showId, languageCode, organiserCompanyId]);

  return [buildTypes, isLoading];
};
